// @import dependencies
import React, { CSSProperties } from 'react'
// @end dependencies

// @import components
import RatingCard from 'app_components/commons/RatingCard/RatingCard';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import Slider from 'react-slick';
import IconComponent from 'app_components/commons/icons';
// @end components

// @import types
import { IReferences } from 'app_types/admin/landings/landingTypes';
// @end types

// @import services
import ArrayService from 'app_services/array/arrayService';
// @end services

// @import hooks
import useWindowWidth from 'app_hooks/useWindowWidth';
import { useColors } from 'app_hooks/useColors';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ReferencesSliderModule.scss'
// @end styles

interface IReferencesSliderModuleProps {
  references: IReferences[]
  className?: string
  style?: CSSProperties
  id?: string
  title?: string;
  random?: boolean;
}

const ReferencesSliderModule: React.FC<IReferencesSliderModuleProps> = (props) => {

  const [colors] = useColors();
  const { windowWidth } = useWindowWidth();

  // @INFO Services
  const arrayService = new ArrayService();

  const getNumberItems = () => {
    if(windowWidth < 850){
      return 1
    }
    if(windowWidth < 1250){
      return 2
    }
    return 3
  }

  const getReferences = () => {
    let response: IReferences[] = [];
    if (props.references?.length) {
      response = props.references;
    }
    if (props.random) {
      response = arrayService.shuffle(response);
    }
    return response;
  }

  return(
    <div
      className={`references_slider_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      {props.title && (
        <TextComponent
          type='title'
          style={{
            textAlign: 'center'
          }}
          styleDiv={{
            justifyContent: 'center'
          }}
        >
          {props.title}
        </TextComponent>
      )}
      <div className="container-rating-card">
        <Slider
          arrows={true}
          className='slider-page'
          infinite={(props.references?.length >= getNumberItems()) ? true : false}
          slidesToShow={getNumberItems()}
          nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
          prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
        >
          {getReferences()?.map((reference) => (
            <div
              key={reference.unique}
              className='container-item-slider'
            >
              <RatingCard
                avatar={reference?.url || ''}
                description={reference?.description || ''}
                stars={(reference?.qualification) ? parseInt(reference?.qualification) : 0}
                title={reference?.title || ''}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

// ======================================
// Flecha
// ======================================
const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}

export default ReferencesSliderModule;
